// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  APP_URL: 'https://ff-nxt-api.dev.fitnessforce.com',
  BASE_URL: 'https://ff-nxt-api.dev.fitnessforce.com',
  // BASE_URL: 'https://ffv4staging.fitnessforce.com',
  domain_suffix: 'fitnessforcenxt.com',
  Ip_Api_URL: "https://pro.ip-api.com/json/?key=MAkQGoxG3ZmGnth",
  googleGTM:"GTM-WQZTW6V", // Only for testing ...
  hj:"3014151",//Hotjar Tracking Code (Site ID)
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
